module.exports = __webpack_public_path__ + "img/WP2023-Exhibitors.5ae4358d.jpg";